<template>
    <div>
        <va-select @change="setRecordPerPage" v-model="currentRecordsPerPage" no-uncheck>
            <va-option value="10" label="10"></va-option>
            <va-option value="20" label="20"></va-option>
            <va-option value="25" label="25"></va-option>
            <va-option value="50" label="50"></va-option>
            <va-option value="100" label="100"></va-option>
        </va-select>
    </div>

</template>

<script>
    import Parse from "@/main.js"
    import { mapActions, mapGetters } from "vuex";
    export default {

        data() {
            return {
                currentRecordsPerPage: 10,
            }
        },


        methods: {
            setRecordPerPage() {
                if (this.$route.fullPath.includes('?')) {
                    if (this.$route.query) {
                        var route = '';
                        if (this.$route.query['filterId']) {
                            route = this.$route.path + '?filterId=' + this.$route.query['filterId'] + '&perPage=' + this.currentRecordsPerPage.toString()
                        } else {
                            route = this.$route.path + '?perPage=' + this.currentRecordsPerPage.toString()
                        }
                        this.$router.replace(route)
                    }

                } else {
                    this.$router.replace(this.$route.fullPath + '?perPage=' + this.currentRecordsPerPage.toString())
                }
            }
        },

        mounted() {
            if (this.$route.query && this.$route.query['perPage']) {
                this.currentRecordsPerPage = this.$route.query['perPage']
            } else {
                this.currentRecordsPerPage = 10
            }
        }
    }
</script>

<style>

</style>